import React, { useEffect, useState } from "react";
import { PartyPopper, X } from "lucide-react";

const COLORS = ["#264839", "#B8860B", "#B35C4A", "#7D8C85", "#11211A"];
const PIECES = Array.from({ length: 28 }, (_, i) => ({ id: i, left: (i * 37) % 100, delay: (i % 7) * 0.12, dur: 2.2 + (i % 5) * 0.3, color: COLORS[i % COLORS.length], rot: (i * 53) % 360 }));

// One-time "all set" moment when the last claimed-checklist step ticks off (remembered per user in localStorage).
// Only fires for suppliers who previously saw the checklist incomplete in this browser (no surprise for long-time paid suppliers).
export default function ChecklistCelebration({ userId, allDone }) {
  const key = `checklist_celebrated_${userId}`;
  const seenKey = `checklist_seen_incomplete_${userId}`;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!allDone) { localStorage.setItem(seenKey, "1"); return; }
    if (localStorage.getItem(seenKey) && !localStorage.getItem(key)) { localStorage.setItem(key, new Date().toISOString()); setOpen(true); }
  }, [allDone, key, seenKey]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-[#11211A]/60 flex items-center justify-center p-4 overflow-hidden" onClick={() => setOpen(false)} data-testid="checklist-celebration">
      <style>{`@keyframes as-confetti{0%{transform:translateY(-10vh) rotate(0deg);opacity:1}100%{transform:translateY(110vh) rotate(720deg);opacity:0}}`}</style>
      {PIECES.map((p) => (
        <span key={p.id} aria-hidden className="absolute top-0 w-2 h-3 pointer-events-none" style={{ left: `${p.left}%`, background: p.color, transform: `rotate(${p.rot}deg)`, animation: `as-confetti ${p.dur}s ${p.delay}s ease-in forwards` }} />
      ))}
      <div className="relative bg-white w-full max-w-md p-8 text-center shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={() => setOpen(false)} className="absolute top-3 right-3 text-[#7D8C85] hover:text-[#11211A]" data-testid="checklist-celebration-close"><X className="w-4 h-4" /></button>
        <div className="mx-auto w-14 h-14 rounded-full bg-[#264839] text-white flex items-center justify-center"><PartyPopper className="w-7 h-7" /></div>
        <div className="tracking-overline text-[10px] text-[#B35C4A] mt-5">Checklist complete</div>
        <h2 className="font-serif text-3xl text-[#11211A] mt-1">You're all set</h2>
        <p className="text-sm text-[#4A5550] mt-3 leading-relaxed">Logo, description and plan — done. Your listing is as polished as it gets, and buyers can find you today.</p>
        <button type="button" onClick={() => setOpen(false)} className="btn-primary text-xs mt-6" data-testid="checklist-celebration-dismiss">Back to my dashboard</button>
      </div>
    </div>
  );
}
